import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/app/store";
import { useGetCountryStateListDataQuery } from "@/services/countryState/countryStateReducer";
import { setCountryList } from "./country-slice";
export const useCountryHook = () => {
  const dispatch = useDispatch();
  const countryList = useSelector((state: RootState) => state.country.countryList);
  const { data, error, isLoading } = useGetCountryStateListDataQuery();
  useEffect(() => {
    if (!countryList.length && data) {
      dispatch(setCountryList(data));
    }
  }, [countryList, data, dispatch]);

  return { countryList, error, isLoading };
};